
































































import { Prop, Component, Mixins, Watch } from "vue-property-decorator";
import AbcInput from "../input/AbcInput.vue";
import InputMixin from "../private/InputMixin";
import WithItemsMixin from "../private/WithItemsMixin";
import PrivatePopover from "../popover/PrivatePopover.vue";
import ID from "../../ID";

@Component({
    components: {
        AbcInput,
        PrivatePopover,
    },
})
export default class AbcAutocomplete extends Mixins(InputMixin, WithItemsMixin) {
    @Prop({ default: -1 }) decimals!: number;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isFocused!: boolean;
    @Prop({ type: Boolean }) isNumeric!: boolean;
    @Prop({ default: null }) readonly label!: string | null;
    @Prop({ default: null }) info!: string | null;
    @Prop({ type: Boolean }) leftTools!: boolean;
    @Prop() maxHeight!: string;
    @Prop({ default: 100 }) maxlength!: number;
    @Prop({ default: null }) placeholder!: string | null;
    @Prop({ type: Boolean }) rightTools!: boolean;
    @Prop({ type: Boolean }) buttons!: boolean;
    @Prop({ default: (v: unknown) => v, type: Function }) readonly stringify!: (v: unknown) => string;
    @Prop() readonly search!: string;

    private isPopperOpen = false;
    private popperUId = ID.next();
    private width = 0;

    get input() {
        return this.search;
    }
    set input(val: string) {
        if (!this.isPopperOpen) {
            this.isPopperOpen = true;
        }
        if (val === "") {
            this.$emit("input", null);
        }
        this.$emit("update:search", val);
    }

    mounted() {
        this.onValueChange();

        let tempInput;
        if (this.value === null) {
            tempInput = "";
        } else {
            tempInput = this.stringify(this.value);
        }
        this.input = tempInput;
        this.isPopperOpen = false;
    }

    togglePopper() {
        if (this.isPopperOpen) {
            this.isPopperOpen = false;
        } else {
            const el = document.getElementById("popperRef" + this.popperUId);
            this.width = el?.getBoundingClientRect().width || 0;
            this.isPopperOpen = true;
        }
    }

    private onFirstChange = true;
    @Watch("value")
    onValueChange() {
        if (this.value && this.items) {
            this.curIndex = this.items.findIndex((it) => this.isEqual(it, this.value));
        } else {
            this.curIndex = -1;
        }

        if(this.value && !this.onFirstChange){
            this.runRules(this.value);
        }
        this.onFirstChange = false;
    }
    private onClick(index: number) {
        const item = this.items ? this.items[index] : null;
        if (item) {
            this.$emit("input", item);
            this.$emit("update:search", this.stringify(item));
            this.isPopperOpen = false;
            this.runRules(item);
        }
    }
    private onBlur() {
        let tempInput;
        if (this.value === null) {
            tempInput = "";
        } else {
            tempInput = this.stringify(this.value);
        }
        this.runRules(this.value);
        this.input = tempInput;
        this.isPopperOpen = false;
    }

    handleKeyDown(e: KeyboardEvent) {
        if (this.isPopperOpen) {
            this.handleKey(e);
        }
    }
    @Watch("clickedItem")
    onEnterPressed(val: number) {
        this.onClick(val);
    }

    get popUpStyle() {
        return {
            maxHeight: this.maxHeight,
        };
    }

    listClass(index: number) {
        const selected = this.items ? this.isEqual(this.items[index], this.value) : false;
        const current = this.curIndex === index;
        return {
            [this.followMouse]: !!this.followMouse,
            "bg-bg-500": current && !selected,
            "bg-border dark:bg-border-dark": selected,
        };
    }
}
